<template>
    <div>
        <div class="modal fade" id="modalShow" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true"
             style="position: fixed;">
            <button type="button" class="closeXReject" id="closeModal" data-dismiss="modal" aria-label="Close"
                    hidden></button>
            <div class="modal-dialog lg" role="document">
                <div class="modal-content">
                    <div data-cy="reserve_modal_title" class="modal-header hearder-custom">
                        <div>
                            <h4 class="modal-title">Realmente deseja rejeitar a proposta?</h4>
                            <button type="button" class="close close-custom" id="close" data-dismiss="modal"
                                    aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <div class="modal-body hearder-custom reject-proposal-modal-body">
                        <SectionCardComponent
                                eyebrow="Atenção"
                                title="Rejeitar proposta"
                                subtitle="Revise os dados antes de confirmar a rejeição."
                                icon="icon-info-with-circle"
                                custom-class="reject-proposal-warning-card">
                            <div class="reject-proposal-alert">
                                Esta ação rejeita a proposta selecionada e exige uma justificativa.
                            </div>
                        </SectionCardComponent>

                        <SectionCardComponent
                                eyebrow="Proposta"
                                title="Dados vinculados"
                                subtitle="Informações principais da proposta selecionada."
                                icon="icon-grid"
                                custom-class="reject-proposal-section-card">
                            <div class="reject-proposal-info-grid">
                                <div class="reject-proposal-info-item">
                                    <span>{{ t('LOTS.BLOCK') }}</span>
                                    <strong>{{ proposal?.properties?.block }}</strong>
                                </div>
                                <div class="reject-proposal-info-item">
                                    <span>{{ t('LOTS.LOT') }}</span>
                                    <strong>{{ proposal?.properties?.name }}</strong>
                                </div>
                                <div class="reject-proposal-info-item reject-proposal-info-item--wide">
                                    <span>{{ t('RESERVE.REALTOR') }}</span>
                                    <strong>{{ proposal?.user_name }}</strong>
                                </div>
                            </div>
                        </SectionCardComponent>

                        <SectionCardComponent
                                eyebrow="Motivo"
                                title="Justificativa da rejeição"
                                subtitle="Informe o motivo com no mínimo 10 caracteres."
                                icon="icon-pencil"
                                custom-class="reject-proposal-section-card">
                            <div class="form-group mb-0">
                                <label for="reason_revocation" class="required">Motivo para rejeitar a proposta:</label>
                                <textarea class="form-control reject-proposal-textarea" id="reason_revocation" cols="20" rows="6"
                                          v-model="proposal.motive_reject">
                                </textarea>
                                <p class="red reject-proposal-help-text">Mínimo 10 caracteres</p>
                            </div>
                        </SectionCardComponent>

                        <div class="reject-proposal-footer-actions">
                            <button data-cy="reserve_modal_close" type="button"
                                    class="btn btn-secondary mr-1 width-buttons" @click="closeModal">
                                {{ t('ACTIONS.CLOSE') }}
                            </button>
                            <button data-cy="reserve_modal_confirm" type="button"
                                    class="btn btn-primary mr-1 width-buttons" @click="rejectProposal()">
                                {{ t('ACTIONS.CONFIRM') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="closeModalRejectProposal"></div>
    </div>
</template>

<script>
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import Proposal from '../../services/Proposal';
import SectionCardComponent from '@/components/layouts/SectionCardComponent.vue';

export default {
    name: "modalRejectProposal",
    components: {SectionCardComponent},
    props: ['proposalIndex', 'modalInstance', 'position'],
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            proposal:{motive_reject:null},
        }
    },
    mounted() {
        this.proposal = this.proposalIndex;
    },
    emits:['proposalRejected'],
    watch:{
        proposalIndex(){
            this.proposal = this.proposalIndex;
        }
    },
    methods:{
        closeModal(){
            this.modalInstance.hide();
            const backdrops = document.getElementsByClassName('modal-backdrop');
            if (backdrops[1] && this.position === 'two') {
                document.body.removeChild(backdrops[1]);
            }else if (backdrops[0] && this.position === 'one'){
                document.body.removeChild(backdrops[0]);
            }
        },
        rejectProposal() {
            if (!this.proposal?.motive_reject || this.proposal?.motive_reject?.length < 10){
                this.toast.error('Necessário informar um motivo para rejeição com no mínimo 10 caracteres');
                return;
            }
            this.$store.commit('changeLoading', true);
            Proposal.rejectProposal(this.proposal).then(() => {
                this.closeModal();
                this.toast.success(this.t('PROPOSAL.REJECTE_SUCCESS'));
                this.$emit('proposalRejected', this.proposal);
            }).catch((err) => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
        },
    }
}
</script>

<style scoped>
.reject-proposal-modal-body {
    padding: 0 1rem 1rem !important;
}

.reject-proposal-section-card,
.reject-proposal-warning-card {
    margin-bottom: 12px !important;
}

.reject-proposal-warning-card {
    border-color: rgba(214, 76, 54, 0.22) !important;
}

.reject-proposal-alert {
    background: rgba(214, 76, 54, 0.08);
    border-left: 4px solid #d64c36;
    border-radius: 10px;
    color: #6f2b21;
    font-size: 0.86rem;
    font-weight: 700;
    line-height: 1.35;
    padding: 0.75rem 0.9rem;
}

.reject-proposal-info-grid {
    display: grid;
    gap: 0.65rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-bottom: 12px;
}

.reject-proposal-info-item {
    background: rgba(231, 244, 240, 0.52);
    border: 1px solid rgba(14, 94, 78, 0.08);
    border-radius: 12px;
    min-width: 0;
    padding: 0.65rem 0.75rem;
}

.reject-proposal-info-item--wide {
    grid-column: span 2;
}

.reject-proposal-info-item span {
    color: #6b7c78;
    display: block;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    margin-bottom: 0.15rem;
    text-transform: uppercase;
}

.reject-proposal-info-item strong {
    color: #173b34;
    display: block;
    font-size: 0.9rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.reject-proposal-textarea {
    min-height: 120px;
    resize: vertical;
}

.reject-proposal-help-text {
    color: red;
    font-size: 0.75rem;
    font-weight: 700;
    margin: 0.35rem 0 0;
}

.reject-proposal-footer-actions {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    padding-top: 0.25rem;
}

.width-buttons {
    width: 30%;
}

:global(html.dark-theme .reject-proposal-alert) {
    background: rgba(251, 113, 133, 0.12) !important;
    border-left-color: var(--dark-danger) !important;
    color: var(--dark-text) !important;
}

:global(html.dark-theme .reject-proposal-info-item) {
    background: var(--dark-primary-soft) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .reject-proposal-info-item span) {
    color: var(--dark-text-soft) !important;
}

:global(html.dark-theme .reject-proposal-info-item strong) {
    color: var(--dark-text) !important;
}

@media (max-width: 575px) {
    .reject-proposal-info-grid {
        grid-template-columns: 1fr;
    }

    .reject-proposal-info-item--wide {
        grid-column: span 1;
    }

    .reject-proposal-footer-actions .btn {
        margin-bottom: 0.35rem;
        width: 100%;
    }
}
</style>
